import * as ElcEcommCommands from './fe-elc-ecomm';
import * as ElcServiceCartCommands from './fe-elc-service-cart';
import * as ElcServiceProdcatCommands from './fe-elc-service-prodcat';
import * as ElcServiceSignInCommands from './fe-elc-service-sign-in';
import * as ElcServiceUserProfileCommands from './fe-elc-service-user-profile';
import * as ElcServiceOrderCommands from './fe-elc-service-order';

const serviceCommands = {
    ...ElcEcommCommands,
    ...ElcServiceCartCommands,
    ...ElcServiceOrderCommands,
    ...ElcServiceProdcatCommands,
    ...ElcServiceSignInCommands,
    ...ElcServiceUserProfileCommands
};

type ServiceCommands = ElcServiceCartCommands.ServiceCartCommands &
    ElcEcommCommands.ServiceElcEcommCommands &
    ElcServiceOrderCommands.ServiceOrderCommands &
    ElcServiceProdcatCommands.ServiceProdcatCommands &
    ElcServiceSignInCommands.ServiceSignInCommands &
    ElcServiceUserProfileCommands.ServiceUserProfileCommands;

type ServiceCommandsReturnType = ElcServiceCartCommands.ServiceCartCommandsReturnType &
    ElcEcommCommands.ServiceElcEcommCommandsReturnType &
    ElcServiceOrderCommands.ServiceOrderCommandsReturnType &
    ElcServiceProdcatCommands.ServiceProdcatCommandsReturnType &
    ElcServiceSignInCommands.ServiceSignInCommandsReturnType &
    ElcServiceUserProfileCommands.ServiceUserProfileCommandsReturnType;

export { serviceCommands, ServiceCommands, ServiceCommandsReturnType };
